export default "__VITE_ASSET__BrpBsV2d__"